import { useQuery } from '@tanstack/react-query';

import { SEARCH_ITEMS_PER_PAGE } from 'src/constants';
import { apiRequest } from 'src/helpers/apiRequest';
import { useAppConfig } from 'src/hooks';
import { OrganizationResponsePaginationItemsContainer } from 'src/types/rest/tenant';

export const useOrganization = (name?: string) => {
  const {
    tenancy: { apiHost },
  } = useAppConfig();

  return useQuery({
    enabled: !!name,
    queryFn: () =>
      apiRequest<OrganizationResponsePaginationItemsContainer>({
        url: `${apiHost}/organizations?PageIndex=1&ItemsPerPage=${SEARCH_ITEMS_PER_PAGE}&Query=${encodeURIComponent(name ?? '')}`,
      }),
    queryKey: ['organization', name],
  });
};
